export const normalizeMenuPath = (path: string) => {
  const trimmed = path.trim();

  if (!trimmed) {
    return '';
  }

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      return new URL(trimmed).pathname.replace(/\/$/, '') || '/';
    } catch {
      return trimmed.replace(/\/$/, '') || '/';
    }
  }

  return trimmed.replace(/\/$/, '') || '/';
};
